import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Grid 
} from '@mui/material';
import { colors } from 'styles/colors';
import { TransactionDetailsProps } from './types';

const TransactionDetailsCard: React.FC<TransactionDetailsProps> = ({
  purchaseId,
  transactionId,
  amount,
  providerName,
  status
}) => {
  // Don't render if no transaction details to show
  if (!purchaseId && !transactionId && !amount) {
    return null;
  }

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return colors.successGreen;
      case 'failure':
        return colors.red;
      case 'cancelled':
        return colors.orange;
      default:
        return colors.red;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'success':
        return 'SUCCESSFUL';
      case 'failure':
        return 'FAILED';
      case 'cancelled':
        return 'CANCELLED';
      default:
        return 'FAILED';
    }
  };

  const displayAmount = amount ? parseFloat(amount).toLocaleString() : null;

  return (
    <Card sx={{ mb: 4, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', borderRadius: 2 }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={600} color={colors.fontDarkBlue} sx={{ mb: 2 }}>
          Transaction Details
        </Typography>
        <Grid container spacing={2}>
          {purchaseId && (
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color={colors.fontLight}>
                Purchase ID
              </Typography>
              <Typography variant="body1" fontWeight={600} color={colors.fontDarkBlue}>
                {purchaseId}
              </Typography>
            </Grid>
          )}
          {transactionId && (
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color={colors.fontLight}>
                Transaction ID
              </Typography>
              <Typography variant="body1" fontWeight={600} color={colors.fontDarkBlue}>
                {transactionId}
              </Typography>
            </Grid>
          )}
          {displayAmount && (
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color={colors.fontLight}>
                Amount {status === 'success' ? 'Paid' : 'Attempted'}
              </Typography>
              <Typography variant="body1" fontWeight={600} color={colors.fontDarkBlue}>
                ₹{displayAmount}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color={colors.fontLight}>
              Payment Status
            </Typography>
            <Typography variant="body1" fontWeight={600} color={getStatusColor()}>
              {getStatusText()}
            </Typography>
          </Grid>
          {providerName && (
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color={colors.fontLight}>
                Service Provider
              </Typography>
              <Typography variant="body1" fontWeight={600} color={colors.fontDarkBlue}>
                {providerName}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color={colors.fontLight}>
              {status === 'success' ? 'Purchase Date & Time' : 'Attempt Date & Time'}
            </Typography>
            <Typography variant="body1" fontWeight={600} color={colors.fontDarkBlue}>
              {new Date().toLocaleDateString('en-IN', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}, {new Date().toLocaleTimeString('en-IN', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TransactionDetailsCard;